export const username = "arpanaditya";
export const API_URL = "https://api.github.com";